import {
  ChatCreateData,
  ChatWithShortInfo,
  MetaResponseChats,
  SwitchChatArchiveData,
  UpdateChat
} from "@sms/shared/chat/chat.interface";
import { ActionCreatorWithPayload, ActionCreatorWithoutPayload, createAction } from "@reduxjs/toolkit";

//Handlers
const switchSelectChat: ActionCreatorWithPayload<string | null> = createAction("chat/handleChangeCurrent");

const switchCurrentChatArchive: ActionCreatorWithPayload<SwitchChatArchiveData> =
  createAction("chat/handleSwitchToArchive");

const createChat: ActionCreatorWithPayload<ChatCreateData> = createAction("chat/createChat");

const updateChat: ActionCreatorWithPayload<UpdateChat> = createAction("chat/updateChat");

const resetChats: ActionCreatorWithoutPayload = createAction<void>("chat/reset");

//Set data
const setChatsWithShortInfo: ActionCreatorWithPayload<ChatWithShortInfo[]> = createAction("chat/setWithShortInfo");

const setMetaChats: ActionCreatorWithPayload<MetaResponseChats | null> = createAction("chat/setMeta");

export default {
  switchSelectChat,
  switchCurrentChatArchive,
  createChat,
  updateChat,
  setChatsWithShortInfo,
  setMetaChats,
  resetChats
};
